import { render } from "./RoleTag.vue?vue&type=template&id=46b10d5f&ts=true"
import script from "./RoleTag.vue?vue&type=script&lang=ts"
export * from "./RoleTag.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QChip from 'quasar/src/components/chip/QChip.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QChip});
